import 'css-chunk:src/app/containers/MemberDetail/components/MemberDetails/components/Permissions/Permissions.scss';export default {
  "label": "_label_160dj_1",
  "value": "_value_160dj_6"
};